<div id="associate-search-modal">
  <div id="associate-search-modal-header">
    <div id="associate-search-modal-buttons">
      <div id="associate-search-buttons-left">
        @if (searchResults?.length) {
          <universal-button
            id="associate-search-back-button"
            data-automation="associateSearchBackButton"
            [data]="{ size: 'small', type: 'tertiary', buttonType: 'button', disabled: false }"
            (click)="onBackClicked()"
          >
            <span class="fas fa-arrow-left"></span> &nbsp;
            {{ labels.back }}
          </universal-button>
        }
      </div>

      <div>
        <universal-button
          id="associate-search-close-button"
          data-automation="associateSearchCloseButton"
          [data]="{ type: 'close', buttonType: 'button', disabled: false }"
          (click)="onCloseClicked()"
          >&times;</universal-button
        >
      </div>
    </div>

    <h3 id="associate-search-title">{{ labels.title }}</h3>
  </div>

  <div id="associate-search-modal-content">
    @if (!searchResults?.length) {
      <div id="associate-search-modal-search-form">
        @if (searchResult?.data && previousSearchTerm) {
          <div id="associate-search-no-results">
            {{ labels['no-results'] }} "{{ previousSearchTerm }}"
          </div>
        }
        <form id="associate-search-form" [formGroup]="associateSearchForm" (ngSubmit)="onAssociateSearch()">
          <universal-form-input-text
            id="associate-search-id"
            automationId="associateSearchId"
            formControlName="id"
            [label]="labels['usana-id-number']"
            [data]="associateSearchIdData"
          ></universal-form-input-text>
          <div id="associate-search-or">
            <div class="associate-search-or-line"></div>
            <span class="associate-search-or-text">{{ labels.or?.toUpperCase() }}</span>
            <div class="associate-search-or-line"></div>
          </div>
          <universal-form-input-text
            id="associate-first-name"
            automationId="associateFirstName"
            formControlName="firstName"
            [label]="labels['first-name']"
            [data]="associateFirstNameData"
          ></universal-form-input-text>
          <universal-form-input-text
            id="associate-last-name"
            automationId="associateLastName"
            formControlName="lastName"
            [label]="labels['last-name']"
            [data]="associateLastNameData"
          ></universal-form-input-text>
          <universal-button
            id="associate-search-button"
            data-automation="associateSearchButton"
            [data]="{ size: 'full', type: 'primary', buttonType: 'submit', disabled: associateSearchForm.invalid }"
            >{{ labels['search-button'] }}</universal-button
          >
        </form>
      </div>
    } @else {
      <div id="associate-search-results">
        @for (result of searchResults; track result) {
          <div class="associate-search-result">
            <div class="associate-search-result-image">
              <img src="assets/enu-IN/images/associate-search-profile.svg" alt="user-image" />
            </div>
            <div class="associate-search-result-details">
              <div>USANA ID: {{ result.customerId }}</div>
              <div>{{ result.firstName }} {{ result.lastName }}</div>
              <div>District: {{ result.district }}</div>
              @if (result.classification !== DELISTED_CLASSIFICATION) {
                <div class="associate-search-result-active">Active</div>
              } @else {
                <div class="associate-search-result-inactive">Inactive</div>
              }
            </div>
          </div>
        }
      </div>
    }
  </div>
</div>
